module.exports = __webpack_public_path__ + "static/media/camera_icon_orange.66ddb94f.svg";